// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"20aa7608","453":"964db593"}[chunkId] + ".chunk.js";
};